/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type chat_user$ref = any;
export type chat_user = {
    readonly createdDate: string | null;
    readonly isTrade: boolean | null;
    readonly hasVipPermission: boolean | null;
    readonly profile: {
        readonly email: string | null;
        readonly firstName: string | null;
        readonly lastName: string | null;
    } | null;
    readonly roles: {
        readonly roleList: ReadonlyArray<{
            readonly name: string | null;
            readonly createdDate: string | null;
            readonly userData: {
                readonly userStatus: {
                    readonly name: string | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": chat_user$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "createdDate",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "chat_user",
        "type": "User",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": "isTrade",
                "name": "hasPermission",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_VERIFIED_TRADE"
                    }
                ],
                "storageKey": "hasPermission(name:\"B_VERIFIED_TRADE\")"
            },
            {
                "kind": "ScalarField",
                "alias": "hasVipPermission",
                "name": "hasPermission",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_VIP_CHECKOUT"
                    }
                ],
                "storageKey": "hasPermission(name:\"B_VIP_CHECKOUT\")"
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "profile",
                "storageKey": null,
                "args": null,
                "concreteType": "Profile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "email",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "roles",
                "storageKey": null,
                "args": null,
                "concreteType": "UserRoles",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "roleList",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Role",
                        "plural": true,
                        "selections": [
                            (v1 /*: any*/),
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "userData",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserRoleData",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "userStatus",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "UserRoleUserData",
                                        "plural": false,
                                        "selections": [
                                            (v1 /*: any*/)
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '981607052444a92223b691af40c51196';
export default node;
